module.exports = __webpack_public_path__ + "img/cancel-subscription.edb2b4bb.svg";